module.exports = __webpack_public_path__ + "static/media/Digital Health  - Icon.df7965b4.svg";